import { useEffect, useState } from "react";

const Leetcode = () => {
  return (
    <>
      {/* <div className="border border-yellow-600 p-3 rounded mt-2 w-full flex">
        <div>
          <img
            className="w-10"
            src="https://leetcode.com/static/images/LeetCode_logo_rvs.png"
          />
        </div>
        <div className="mt-1"> this leetcode stats</div>
      </div> */}
    </>
  );
};

export default Leetcode;
